
import React from 'react';
import { FileText } from 'lucide-react';
import { SelectField, SelectOption, ToggleField } from './components';

interface ESGReportsTabProps {
  editing: boolean;
}

// Define the component type with an Icon static property
interface ESGReportsTabComponent extends React.FC<ESGReportsTabProps> {
  Icon: typeof FileText;
}

const ESGReportsTab: ESGReportsTabComponent = ({ editing }) => {
  const reportStandards: SelectOption[] = [
    { value: 'gri', label: 'Global Reporting Initiative (GRI)' },
    { value: 'sasb', label: 'SASB Standards' },
    { value: 'tcfd', label: 'TCFD Framework' },
    { value: 'cdp', label: 'CDP' }
  ];

  const reportFrequencies: SelectOption[] = [
    { value: 'monthly', label: 'Monthly' },
    { value: 'quarterly', label: 'Quarterly' },
    { value: 'annually', label: 'Annually' },
    { value: 'custom', label: 'Custom' }
  ];

  return (
    <div className="grid gap-4">
      <SelectField
        id="report-standard"
        label="ESG Reporting Standard"
        options={reportStandards}
        defaultValue="gri"
        disabled={!editing}
      />
      
      <SelectField
        id="report-frequency"
        label="Reporting Frequency"
        options={reportFrequencies}
        defaultValue="quarterly"
        disabled={!editing}
      />
      
      <ToggleField
        id="auto-generate"
        label="Auto-generate Reports"
        description="Automatically generate scheduled reports"
        checked={true}
        disabled={!editing}
      />
    </div>
  );
};

// Assign the Icon property
ESGReportsTab.Icon = FileText;

export default ESGReportsTab;
